import axios, { AxiosInstance } from "axios";

const http: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_CONSOLE_ADAPTER_API,
    timeout: 10 * 1000,
});

export default http;
